import { computed, inject, Injectable, signal } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { TaxService, TaxSummary } from '../../../../../../../../api';
import { QueryKey } from '../../../../../../../constants/query-key';

interface TaxFilter {
  searchTerm?: string | null;
}

@Injectable()
export class TaxQueryService {
  private readonly taxService = inject(TaxService);

  filterParams = signal<TaxFilter>({ searchTerm: null });

  taxesQuery = injectQuery(() => ({
    queryKey: [QueryKey.TAXES, this.filterParams()],
    queryFn: () => lastValueFrom(this.taxService.getTaxes(this.filterParams().searchTerm ?? null)),
  }));

  taxes = computed<TaxSummary[]>(() => this.taxesQuery.data()?.taxes ?? []);
  isLoading = computed(() => this.taxesQuery.isLoading());

  editingTaxId = signal<number | null>(null);

  private readonly taxDetailQuery = injectQuery(() => ({
    queryKey: [QueryKey.TAX, this.editingTaxId()],
    queryFn: () => lastValueFrom(this.taxService.getTaxById(this.editingTaxId()!)),
    enabled: this.editingTaxId() !== null,
  }));

  taxDetails = computed(() => this.taxDetailQuery.data()?.tax ?? null);
}
